import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Context
import { CartProvider } from "./contexts/CartContext";

// Layout Components
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CartModal from "./components/CartModal";

// Pages
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Reservas from "./pages/Reservas";
import OrderCheckout from "./pages/OrderCheckout";
import OrderSuccess from "./pages/OrderSuccess";
import Nosotros from "./pages/Nosotros";
import Galeria from "./pages/Galeria";
import GiftCards from "./pages/GiftCards";
import Contacto from "./pages/Contacto";
import Resenas from "./pages/Resenas";
import Blog from "./pages/Blog";
import Experiencias from "./pages/Experiencias";
import Privacidad from "./pages/Privacidad";
import Terminos from "./pages/Terminos";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Header />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/reservas" element={<Reservas />} />
              <Route path="/order-checkout" element={<OrderCheckout />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              {/* Placeholder routes for future pages */}
              <Route path="/nosotros" element={<Nosotros />} />
              <Route path="/galeria" element={<Galeria />} />
              <Route path="/galeria" element={<div className="pt-24 p-8 text-center">Página Galería - En construcción</div>} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/gift-cards" element={<GiftCards />} />
              <Route path="/resenas" element={<Resenas />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/experiencias" element={<Experiencias />} />
              <Route path="/privacidad" element={<Privacidad />} />
              <Route path="/terminos" element={<Terminos />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <CartModal />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;